export const SET_ALL_CONVERSATIONS = "Setzt alle Conversations";
export const SET_CURRENT_CONVERSATION = "Setzt den/das aktuelle Conversation";
export const SET_LOCK = "Setzte das Lock für den Conversation";
export const SET_ATTACHMENTS = "Überschreibt die Attachments im Conversation";
export const SET_LOCAL_ATTACHMENTS = "Setzt die Local Attachments";
